import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { PrimeModule } from '@shared/prime/prime.module';
import { TableColumn } from '@shared/interfaces/table-column.type';
import { ViewPortService } from '@shared/services/view-port.service';
import { MatTooltip } from '@angular/material/tooltip';

@Component({
  selector: 'tr[appPTableHeader]',
  standalone: true,
  imports: [PrimeModule, MatTooltip],
  templateUrl: './p-table-header.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class PTableHeaderComponent {
  columns = input<TableColumn[]>([]);
  protected viewPortService = inject(ViewPortService);
}
